import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useProductGroupStore } from "shared/products/groups/stores/productGroupStore";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface DeleteProductGroupRequest {
  groupId: string;
}

export interface DeleteProductGroupSuccessResponse {
  ok: true;
}

export function useDeleteProductGroup() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useProductGroupStore();

  return {
    execute
  };

  async function execute(action: DeleteProductGroupRequest) {

    const {
      groupId
    } = action;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`product/group/${groupId}`), {
      method: 'DELETE',
      headers,
    });

    const text = translations.value.productGroups.actions.delete;

    const response = await httpClient.action<DeleteProductGroupSuccessResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk() {
        store.remove(groupId);
        return Promise.resolve({
          ok: true
        });
      },
    });

    return response;
  }
}
